import { Meal } from '@akin-home/meals';
import { useGetRecipe } from '@akin-home/recipes/react';
import { Text } from '@akin-home/text/native';
import { format } from 'date-fns';
import styled from 'styled-components/native';
import useRecordImage from '../../images/hooks/useRecordImage';

interface Props {
  meal: Meal;
}

const edits = {
  resize: {
    width: 200,
    height: 80,
    fit: 'cover',
  },
};

export const SmallDashboardMealItem = (props: Props) => {
  const { meal } = props;
  const recipe_id = meal.recipes?.[0]?.id;

  const { data: record } = useGetRecipe({ id: recipe_id });

  const { source } = useRecordImage({
    record,
    edits,
  });

  return (
    <Container>
      <Image source={source} />
      <TextContainer>
        <Title weight="semibold" numberOfLines={2}>
          {meal.title}
        </Title>
        <Text>{format(meal.start, 'h:mm a')}</Text>
      </TextContainer>
      <MealTypePill>
        <Text variant="p2" weight="semibold" color="white">
          {meal.mealType}
        </Text>
      </MealTypePill>
    </Container>
  );
};

const Container = styled.View`
  padding: 0 16px;
  gap: 16px;
  flex: 1;
`;

const Image = styled.Image`
  width: 100%;
  border-radius: 20px;
  flex: 1;
`;

const TextContainer = styled.View`
  gap: 8px;
`;

const Title = styled(Text)`
  font-size: 20px;
`;

const MealTypePill = styled.View`
  position: absolute;
  top: 10px;
  left: 22px;
  border-radius: 20px;
  background-color: black;
  border-color: white;
  border-width: 1px;
  padding: 10px 16px;
  align-items: center;
  justify-content: center;
`;
